define('message-service/message-service',['require','exports','module','jquery'],function(require,exports,module){
	var jQuery=require('jquery');

	var namespace="MessageService",
		doc=document;
	/**
	 * @memberOf Topic
	 */
	function Topic (opts) {
		this.name=opts.name;
		this.consumers={};
		this.consumerCount=0;
		this.options = opts;
		this.eventkey=namespace+"::"+opts.name;
		this.target=jQuery(opts.target||window);
		this.bubble=this.target[0]===window;
		this.consumerCount=0;
		this.owner=opts.owner;
	} 
		/**
		 * @memberOf Topic
		 */
	Topic.prototype.publish=function(msg) {
		return this.target.trigger(this.eventkey,msg);				
	};
		/**
		 * @memberOf Topic
		 */
	Topic.prototype.addConsumer=function(scope,consumer,_id,autoRemove) {
		var id=(_id||consumer)+"",
			that=this,
			func;

		if(this.consumers[id]){
			this.removeConsumer(consumer,_id,scope);
		}

		this.consumers[id]=this.consumers[id]||[];
		
		this.consumers[id].push(func=function(e,data){
			if(!that.bubble){
				e.stopPropagation();
			}
			e.data=data;
			if(autoRemove){
				that.removeConsumer(consumer,_id,scope);
			}
			return consumer.call(scope,data,e);
		});
		func.scope=scope;
		func.originalConsumer=consumer;
		this.consumerCount++;
		that.target.on(this.eventkey,func);
	};
		

	Topic.prototype.removeConsumer=function(consumer,_id,scope) {
		var id=(_id||consumer)+"",
			cons=this.consumers[id];

		if(cons){
			var len=cons.length,
				i=0;
			for(; i<len; i++){
				if(cons[i].originalConsumer===consumer && (!scope || cons[i].scope===scope )){
					this.target.off(this.eventkey,cons[i]);
					this.consumers[id].splice(i,1);
					if(!cons.length){
						delete this.consumers[id];
					}
					this.consumerCount--;
					break;
				}
			}
			if(this.consumerCount<=0){
				this.owner.removeTopic(this.name);
			}
		}
	};


    /**
     * Generate the MessageService api and bind it to object obj.
     * Limit the scope of operation to the DOM element target. (Defaults to window)
     * @param  {mixed}  obj     Any object decendent of Object to apply
     *                          the MessageService api.
     * @param  {DOMElement} [target] DOM element to act as the broadcast point
     *                             for all messages.
     * @return {mixed}          obj is returned after binding operation is complete
     */
	var	bind=function(obj,target){
		var topics={};

		obj.publish=function(topicName, msg) {
			var topic = topics[topicName];
			if(topic) {
				return topic.publish(msg);
			}
		};
			
		obj.on=obj.addListener=function(topicName, callback,id,autoRemove) {
			var topic = topics[topicName];
			if(!topic) {
				topic = new Topic({name:topicName,target:target,owner:obj});
				topics[topicName] = topic;
			}
			if(!callback){
				throw new Error('message-service : no handler specified for topic : ' + topicName);
				return;
			}
			topic.addConsumer(this,callback,id,autoRemove);
		};
			
		obj.off=obj.removeListener=function(topicName, callback,id) {
			var topic = topics[topicName];
			if(topic) {
				topic.removeConsumer(callback,id);
			}
		};
		obj.one=function(topicName, callback,id) {
			obj.on(topicName,callback,id,true);
		};

		obj.removeTopic=function(topicName){
			delete topics[topicName];
		};

		obj.peek=function(){
			return topics;
		};

		return obj;
	};
    /**
     * Generate the MessageService api and run in the scope of the target
     * window.
     * @see  bind
     */
	return bind({
        bind : function(obj,target){
            return bind(obj,target||doc.createElement('div'));
        }
    },window);
});
